<template>
  <button>
    <span>
      <slot></slot>
    </span>
    <font-awesome-icon v-if="icon"
                       :icon="icon">
    </font-awesome-icon>
  </button>
</template>

<script>
export default {
  name: "TheDayButton",
  props: {
    type: {
      type: String,
      default: null,
      validator: ( str ) => ["arrow", "chevron", "ext", "external", "download"].includes( str?.toLowerCase() ),
    },
  },
  computed: {
    icon () {
      let result;

      switch ( this.type?.toLowerCase() ) {
        case "arrow":
        case "chevron": {
          result = ["fas", "chevron-right"];
          break;
        }
        case "ext":
        case "external": {
          result = ["fas", "external-link-alt"];
          break;
        }
        case "download": {
          result = ["fas", "arrow-down"];
          break;
        }
        default: {
          result = null;
          break;
        }
      }
      return result;
    },
  },
};
</script>
